import { render } from "./SignaturePad.vue?vue&type=template&id=1bc6ac54&scoped=true"
import script from "./SignaturePad.vue?vue&type=script&lang=js"
export * from "./SignaturePad.vue?vue&type=script&lang=js"

import "./SignaturePad.vue?vue&type=style&index=0&id=1bc6ac54&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1bc6ac54"]])

export default __exports__